// extracted by mini-css-extract-plugin
module.exports = {"lock":"Lock_lock__2AqmM","lock-icon":"Lock_lock-icon__149GP","lock-button":"Lock_lock-button__sWD6B"};